



















// vendor
import { defineComponent, PropType, computed } from "@vue/composition-api";
// project
import { NodeTemplates } from "@/components.edit/edit-blueprint";

export default defineComponent({
	props:{
		graph:{
			type:null,
			required:true
		},
		activeNode:{
			type:String
		},
		path:{
			type:Array as PropType<string[]>,
			required:true
		}
	},
	setup(props){
		const displayNodes = computed(() => {
			return props.path.map(id => {
				const node = props.graph.nodes[id];
				const def = NodeTemplates[node.type];
				return {
					id,
					icon: def.icon
				};
			})
		});
		return {
			displayNodes
		};
	}
});

